import { defineStore } from 'pinia'
import * as apiOperations from '@/network/api/operations/operations.api.js'
import * as apiAccounts from '@/network/api/accounts.api.js'
import * as smartTransfers from '@/network/api/smartTransfers.api.js'
import * as terms from '@/network/api/terms.api.js'
import * as cardsCredit from '@/network/api/cards/credit.api.js'
import * as payments from '@/network/api/payments/payments.api.js'
import * as mobilePayments from '@/network/api/mobilePayments.api.js'
import * as batchfile from '@/network/api/batchfile.api.js'
import * as batchApi from '@/network/api/batch.api.js'
import * as creditApi from '@/network/api/credit.api.js'

export const useShareAndSendInfoStore = defineStore('shareAndSendInfoStore', {
    state: () => ({}),
    getters: {},
    actions: {
        async generateShareLink(payload) {
            const res = await apiOperations.generateShareLink(payload)
            return res
        },
        async sendOperationEmailNotification(payload) {
            const res = await apiOperations.sendOperationEmailNotification(payload)
            return res
        },
        async sendOperationSMSNotification(payload) {
            const res = await apiOperations.sendOperationSMSNotification(payload)
            return res
        },
        async sendBulkOperationEmailNotification(payload) {
            const res = await apiOperations.sendBulkOperationEmailNotification(payload)
            return res
        },
        async sendBulkOperationSMSNotification(payload) {
            const res = await apiOperations.sendBulkOperationSMSNotification(payload)
            return res
        },
        async sendMovementEmailNotification(payload) {
            const res = await apiAccounts.sendMovementEmailNotification(payload)
            return res
        },
        async sendMovementSMSNotification(payload) {
            const res = await apiAccounts.sendMovementSMSNotification(payload)
            return res
        },
        async sendNbaIbanEmailNotification(payload) {
            const res = await apiAccounts.sendNbaIbanEmailNotification(payload)
            return res
        },
        async sendNbaIbanSMSNotification(payload) {
            const res = await apiAccounts.sendNbaIbanSMSNotification(payload)
            return res
        },
        async sendSmartTransferSubmissionEmailNotification(payload) {
            const res = await smartTransfers.sendSmartTransferSubmissionEmailNotification(payload)
            return res
        },
        async sendSmartTransferSubmissionSmsNotification(payload) {
            const res = await smartTransfers.sendSmartTransferSubmissionSmsNotification(payload)
            return res
        },
        async sendTermsEmailNotification(payload) {
            const res = await terms.sendTermsEmailNotification(payload)
            return res
        },
        async sendTermsSMSNotification(payload) {
            const res = await terms.sendTermsSMSNotification(payload)
            return res
        },
        async sendFlexTransferEmailNotification(payload) {
            const res = await cardsCredit.sendFlexTransferEmailNotification(payload)
            return res
        },
        async sendFlexTransferSMSNotification(payload) {
            const res = await cardsCredit.sendFlexTransferSMSNotification(payload)
            return res
        },
        async sendPaymentEmailNotification(payload) {
            const res = await payments.sendPaymentEmailNotification(payload)
            return res
        },
        async sendPaymentSMSNotification(payload) {
            const res = await payments.sendPaymentSMSNotification(payload)
            return res
        },
        async sendMobilePaymentEmailNotification(payload) {
            const res = await mobilePayments.sendMobilePaymentEmailNotification(payload)
            return res
        },
        async sendMobilePaymentSmsNotification(payload) {
            const res = await mobilePayments.sendMobilePaymentSmsNotification(payload)
            return res
        },
        async sendBatchfileEmailNotification(payload) {
            const res = await batchfile.sendBatchfileEmailNotification(payload)
            return res
        },
        async sendBatchfileSMSNotification(payload) {
            const res = await batchfile.sendBatchfileSMSNotification(payload)
            return res
        },
        async sendBatchfileXLSEmail(payload) {
            const res = await batchfile.sendBatchfileXLSEmail(payload)
            return res
        },
        async sendBatchfileEntryEmailNotification(payload) {
            const res = await batchfile.sendBatchfileEntryEmailNotification(payload)
            return res
        },
        async sendBatchfileEntrySMSNotification(payload) {
            const res = await batchfile.sendBatchfileEntrySMSNotification(payload)
            return res
        },
        async contacts(payload) {
            const res = await smartTransfers.contacts(payload)
            return res
        },
        async sendBatchPaymentNotificationByEmail(payload) {
            const res = await batchApi.requestBatchPaymentNotificationByEmail(payload)
            return res
        },
        async sendBatchPaymentNotificationBySms(payload) {
            const res = await batchApi.requestBatchPaymentNotificationBySms(payload)
            return res
        },
        async sendBatchPaymentZipByEmail(payload) {
            const res = await batchApi.sendBatchPaymentZipByEmail(payload)
            return res
        },
        async sendFinancialPlanEmail(payload) {
            const res = await creditApi.sendFinancialPlanEmail(payload)
            return res
        },
        async sendSimulationEmail(payload) {
            const res = await creditApi.sendSimulationEmail(payload)
            return res
        }
    }
})
